import { Component, Injectable, OnInit, Input, ElementRef, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from '../../../../../common/services/Group.service';
import { Select2TemplateFunction, Select2OptionData } from 'ng2-select2';
import { OrganizeService } from '../../../../../common/services/Organize.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { UserService } from '../../../../../common/services/User.service';
import * as _ from 'lodash';
import { FieldService } from '../../../../../common/services/Field.service';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { CommonService } from '../../../../../common/services/Common.service';
import { CommentService } from '../../../../../common/services/Comment.service';
import { ApiEvsService } from '../../../../../common/services/ApiEvs.service';
import { environment } from 'environments/environment';
import { ContactService } from '../../../../../common/services/Contact.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { UtilityService } from 'app/common/services/Utility.service';

declare var $: any;
declare const Timer: any;

@Component({
    moduleId: module.id,
    selector: "detail-user",
    templateUrl: './detail_user.component.html',
    styleUrls: ['../detail.css', './user.css'],
    providers: [BsModalService, GroupService, OrganizeService, EvsAddressService,
        UserService, FieldService, CommonService, UploadService, CommentService, ApiEvsService, ContactService]
})

@Injectable()
export class DetailUserComponent implements OnInit {
    @Input() owner;
    public no_image: any = 'assets/images/contact.png';

    @Output('comeback') comeback = new EventEmitter();
    public user: any;
    public message: { class: string, content: string } = null;

    public option_group: any = {};
    public option_organize: any = {};
    public allRole: any = [{ id: '', text: '' }]
    public allGroup: any = [{ id: '', text: '' }]
    public allAccessContact: any = [{ id: '', text: '' }]
    public allAccessTicket: any = [{ id: '', text: '' }]
    public ruleChat: any = [{ id: '', text: '' }]
    public allOrganize: any = [{ id: '', text: '' }]
    public allGender: any = [{ id: '', text: '' }]
    public cities: any = [{ id: '', text: '' }]
    public districts: any = [{ id: '', text: '' }]
    public allStatus: any = [];
    public status_select2: any = [{ id: '', text: '' }]
    public allFillterGroup: any = [];

    public modalRef: any;
    public model: any = { tags: [], $addToSet: {}, $pull: {} };
    public modelGroup: any = {};
    public modelOrganize: any = {};
    public modelUser: any = {};
    public fields: any = [];
    public errorUpdate: any = [];

    public addPhone: boolean = false;
    public addEmail: boolean = false;
    public addFacebook: boolean = false;
    public deletePhone :boolean = true;
    public deleteEmail :boolean = true;
    public deleteFacebook :boolean = true;
    public change_name: boolean = false;
    public tab: string = 'ticket';
    public currentAddMore: string = "";

    public tickets: any = {};
    public currentPage: any = {};
    public totalItem: any = {};
    public totalPage: any = {};
    public page_size: number = 10;
    public is_loading: boolean = false;
    public filter_type: any = 'request' //request | assign || reciver
    public total: number = 0;

    public selected: any = {};
    public fast_status: any;
    public show_action_ticket: boolean = false; //chọn ticket thì mới show, ko thì thoi
    public changed_phone: boolean = false;

    public modelMerge: any = {};
    public listMergeUser: any = {};
    public totalItemMergeUser: any = 0;
    public totalPageMergeUser: any = 0;
    public currentPageMergeUser: number = 1;
    public optionMerge: any = {};

    public modelFilter: any = {};
    public listAgent: any = [];
    public totalItem1: any = 0;
    public totalPage1: any = 0;
    public page_size1: number = 5;
    public currentPage1: number = 1;
    public detailTicket: any = {};
    public is_load_data: boolean = false;
    public customerType: any = [];
    public isSelected: any = { 1: false, 2: false, 3: false, 4: false, 5: false };
    public totalSelected: any = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    public mergeCount: number = 0;
    public selected_tmp: any = {};
    public is_add_org: boolean = false;
    public is_load_district_follow_city: boolean = false;
    public payload_tmp: any = {};
    @ViewChild('templateGroup') templateGroup: ElementRef;
    @ViewChild('templateOrganize') templateOrganize: ElementRef;
    @ViewChild('templateMergeUser') templateMergeUser: ElementRef;

    constructor(
        private toastr: ToastrService,
        private groupService: GroupService,
        private organizeService: OrganizeService,
        private addressService: EvsAddressService,
        private modalService: BsModalService,
        private userService: UserService,
        private fieldService: FieldService,
        private ticketService: TicketService,
        private socketService: SocketService,
        private uploadService: UploadService,
        private commonService: CommonService,
        private commentService: CommentService,
        private apiService: ApiEvsService,
        private contactService: ContactService
    ) {
        this.user = JSON.parse(localStorage.getItem('User'));
    }

    ngOnInit() {
        this.is_load_data = true;

        this.customerType = [
            '--Chọn--',
            {
                id: '',
                text: ''
            }, {
                id: '0',
                text: 'Thường'
            }, {
                id: '1',
                text: 'Bạc'
            }, {
                id: '2',
                text: 'Vàng'
            }, {
                id: '3',
                text: 'Kim cương'
            }
        ]

        this.getRoles();
        this.getGroup();
        this.getAccessTicket();
        this.getAccessContact();
        this.getRuleChat();
        this.getOrganize();
        this.getGender();
        this.getCity();
        this.getMyFields();
        this.listTicket();

        this.option_group = {
            placeholder: { id: '', text: '-Chọn-' },
            templateResult: this.templateResult,
            templateSelection: this.templateSelection
        }

        this.option_organize = {
            placeholder: { id: '', text: '-Chọn-' },
            templateResult: this.templateResult,
            templateSelection: this.templateSelection
        }

        if (this.owner.city_id) {
            this.getDistrict(this.owner.city_id);
        }

        // this.is_load_data = false;
    }

    ngAfterViewInit() {
        setTimeout(function () {
            this.is_load_data = true;

            this.userService.find({ _id: this.owner._id }).toPromise().then(res => {
                if (res.status == 200 && res.error == false) {
                    this.model = _.assign({}, res.data);
                } else {
                    this.model = _.assign({}, this.owner);
                }

                if (this.model.tags && typeof this.model.tags == 'string') {
                    let arr_tags = this.model.tags.split(',');
                    arr_tags = _.map(arr_tags, e => {
                        return {
                            displayValue: e
                        }
                    })
                    this.model.tags = arr_tags;
                } else this.model['tags'] = [];

                if (this.model.facebook && this.model.facebook.constructor.toString().indexOf("Array") == -1) {
                    this.model.facebook = [this.model.facebook];
                }

                this.model.$addToSet = {}
                this.model.$pull = {}

                setTimeout(function () {
                    this.is_load_data = false;
                }.bind(this), 500);
            })
        }.bind(this), 500);
    }

    initTabUser() {
        this.model.quota_chat = this.owner.quota_chat;
        delete this.model.password;
        delete this.model.confirm_password;
    }

    resetPass(template: TemplateRef<any>) {
        this.message = null;
        if (!this.model.password || !this.model.confirm_password) {
            this.toastr.error('Mật khẩu chưa được nhập', '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
        } else if (this.model.password.trim() != this.model.confirm_password.trim()) {
            this.toastr.error('Mật khẩu không chính xác', '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
        } else if (this.model.password.length < 6) {
            this.toastr.error('Mật khẩu nhiều hơn 6 ký tự', '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
        }
        else {
            let config = {
                backdrop: true,
                ignoreBackdropClick: true,
                keyboard: false
            }
            this.modalRef = this.modalService.show(template, config);
        }
    }

    submitChangePass() {
        this.modalRef.hide();
        this.userService.resetPass(this.owner._id, { password: this.model.password }).subscribe(res => {
            if (res.error == false && res.status == 200) {
                this.toastr.success('Thay đổi mật khẩu thành công', '', {
                    timeOut: 1000,
                    positionClass: 'toast-bottom-right'
                });
                this.model.password = this.model.confirm_password = '';
            } else {
                this.toastr.error('Thay đổi mật khẩu không thành công', '', {
                    timeOut: 1000,
                    positionClass: 'toast-bottom-right'
                });
            }
        })
    }

    updateConfigUser() {
        delete this.model.password;
        delete this.model.confirm_password;
        if (this.model && this.model.quota_chat < 0) {
            this.errorUpdate.push("Giới hạn tiếp nhận chat không hợp lệ");
        } else {
            this.updateUser();
        }

    }
    hover(item) {
        this.detailTicket = item;
        this.commentService.list({ where: JSON.stringify({ ticket_id: this.detailTicket._id }), limit: 1 }).subscribe(res => {
            if (res.status == 200 && res.error == false && res.data.comments) {
                this.detailTicket['lastest_comment'] = res.data.comments[0] ? res.data.comments[0] : null;
            }
        })
    }

    changeFilterType(type) {
        if (type != this.filter_type) {
            this.filter_type = type;
            this.listTicket();
        }
    }

    // blockPhone(phone) {
    //     let payload = {
    //         username: this.user.email,
    //         agentId: this.user.agent_id,
    //         phonenumber: phone
    //     }
    //     this.apiService.postFullUrl(environment.api_evs + '/api/blockcall', payload).subscribe(res => {
    //         if (res.status == 'OK') {
    //             this.model.is_block = true;
    //             this.updateUser({ is_block: true });
    //         }
    //     })
    // }

    // unBlockPhone(phone) {
    //     let payload = {
    //         username: this.user.email,
    //         agentId: this.user.agent_id,
    //         phonenumber: phone
    //     }
    //     this.apiService.postFullUrl(environment.api_evs + '/api/unblockcall', payload).subscribe(res => {
    //         if (res.status == 'OK') {
    //             this.model.is_block = false;
    //             this.updateUser({ is_block: false });
    //         }
    //     })
    // }

    uploadAvatar() {
        $('#avatar_' + this.model._id).trigger('click');
    }

    changeAvatar($event) {
        var files = $event.srcElement.files;
        let file = files[0];
        if (file.size > 5 * 1024 * 1024) {
            this.toastr.error("Dung lượng file tối đa 5Mb", 'Lỗi', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        if (/.*\.(png|jpg|jpeg)$/.test(file.name.toLowerCase()) == false) {
            this.toastr.error("Định dạng file gửi không đúng (png, jpg, jpeg)", 'Lỗi', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        this.uploadService.upload(files[0]).then((res: any) => {
            if (!res.error) {
                this.model.avatar = this.commonService.file(res.data);
                // this.updateUser({ avatar: this.model.avatar });
                $event.target.value = null;
            } else {
                this.toastr.error(res.data.message, 'Lỗi', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        })
    }

    openModal(template: TemplateRef<any>, id?: any) {

        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.currentPage1 = 1;
        this.modelFilter = {};
        this.modalRef = this.modalService.show(template, config);
    }

    onSelect(status, ticket_id?: any) {
        if (ticket_id) {
            // var total = this.tickets[status].length;
            // var count = 0;
            this.selected[status][ticket_id] = !this.selected[status][ticket_id];
            // Object.keys(this.selected[status]).forEach(ticket_id => {
            //     if (this.selected[status][ticket_id]) {
            //         count++;
            //         this.show_action_ticket = true;
            //     }
            // })
            // if (total == count) {
            //     this.isSelected[status] = true;
            // } else {
            //     this.isSelected[status] = false;
            // }
            this.isSelected[status] = true;
            this.tickets[status].forEach(e => {
                if (!this.selected[status][e._id]) {
                    this.isSelected[status] = false;
                }
            })
            if (this.selected[status][ticket_id]) this.mergeCount += 1; else this.mergeCount -= 1;
        } else {
            this.isSelected[status] = !this.isSelected[status];

            this.tickets[status].forEach(e => {
                if (this.selected[status][e._id] != this.isSelected[status]) {
                    this.selected[status][e._id] = this.isSelected[status];
                    if (this.selected[status][e._id]) this.mergeCount += 1; else this.mergeCount -= 1;
                }

            });
        }
        // this.show_action_ticket = false;
        // this.allStatus.forEach(status => {
        //     if (this.tickets[status.id]) {
        //         this.tickets[status.id].forEach(e => {
        //             if (this.selected[status.id][e._id]) {
        //                 this.show_action_ticket = true;
        //             }
        //         });
        //     }
        // });
        // console.log(this.mergeCount);
    }

    unSelect() {
        this.show_action_ticket = false;
        this.allStatus.forEach(status => {
            if (this.tickets[status.id]) {
                this.isSelected[status.id] = false;
                this.tickets[status.id].forEach(e => {
                    this.selected[status.id][e._id] = false;
                });
            }
        });
        this.mergeCount = 0;
    }

    changeFastStatus(e: any) {
        this.fast_status = e.value;
    }

    submitMergeTicket() {
        var y = confirm("Bạn có muốn thực hiện hợp nhất các phiếu khi này không?");
        if (y) {
            this.is_load_data = true;
            let ids = [];
            // Merge từ trên xuống, phiếu ghi ở trên cùng là phiếu ghi chính
            this.allStatus.forEach(status => {
                if (this.selected[status.id]) {
                    Object.keys(this.selected[status.id]).forEach(e => {
                        if (this.selected[status.id][e]) {
                            ids.push(e);
                        }
                    });
                }
            });
            this.ticketService.mergeMany(ids).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Hợp nhất phiếu ghi không thành công" };
                        this.toastr.error('Hợp nhất phiếu ghi không thành công', '', {
                            timeOut: 1000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.toastr.success('Hợp nhất phiếu ghi thành công, vui lòng chờ trong giây lát để cập nhật thông tin', '', {
                            timeOut: 2000,
                            positionClass: 'toast-bottom-right'
                        });
                    }
                    setTimeout(() => {
                        this.is_load_data = false;
                        this.listTicket();
                        this.unSelect();
                    }, 4500);
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            })
        }
    }

    submitFastStatus() {
        var y = confirm("Bạn có muốn chuyển trạng thái những phiếu ghi này không?");
        if (y) {
            let ids = [];
            this.allStatus.forEach(status => {
                if (this.selected[status.id]) {
                    Object.keys(this.selected[status.id]).forEach(e => {
                        if (this.selected[status.id][e]) {
                            ids.push(e);
                        }
                    });
                }
            });
            this.is_load_data = true;

            this.ticketService.updateMany({ _id: { $in: ids } }, { status: parseInt(this.fast_status) }).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Chuyển trạng thái không thành công" };
                        this.toastr.error('Chuyển trạng thái không thành công', '', {
                            timeOut: 1000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.toastr.success('Chuyển trạng thái thành công, vui lòng chờ trong giây lát để cập nhật thông tin', '', {
                            timeOut: 2000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.modalRef.hide();
                        setTimeout(() => {
                            this.is_load_data = false;
                            this.listTicket();
                            this.unSelect();
                        }, 4500);
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            })
        }

    }

    changedFilterGroup(e) {
        this.modelFilter.group_id = e.value;
    }

    filterUser() {
        this.optionMerge = [];
        this.currentPageMergeUser = 1;
        if (this.modelMerge.filter_name) {
            this.optionMerge.push({
                key: 'name',
                condition: '=',
                value: this.modelMerge.filter_name
            })
        }
        if (this.modelMerge.filter_email) {
            this.optionMerge.push({
                key: 'email',
                condition: '=',
                value: this.modelMerge.filter_email
            })
        }
        if (this.modelMerge.filter_phone) {
            this.optionMerge.push({
                key: 'phone',
                condition: '=',
                value: this.modelMerge.filter_phone
            })
        }

        this.getListUsers({ filters: JSON.stringify(this.optionMerge) });
        this.modelMerge.searched = true;
    }

    mergeUser(user) {
        var y = confirm("Bạn có muốn hợp nhất người dùng này không?");
        if (y) {
            user.isMerged = true;
            let data = {
                userId: this.model._id,
                mergeUserId: user._id
            }
            this.userService.merge(data).subscribe(res => {
                if (res.status == 200 && res.error == false) {
                    this.toastr.success('Hợp nhất thành công, vui lòng chờ trong giây lát để cập nhật thông tin', '', {
                        timeOut: 2000,
                        positionClass: 'toast-bottom-right'
                    });
                    setTimeout(() => {
                        this.comeback.emit({
                            requester_id: this.owner._id
                        });
                        this.is_load_data = true;

                        this.userService.find({ _id: this.owner._id }).toPromise().then(res => {
                            if (res.status == 200 && res.error == false) {
                                this.model = _.assign({}, res.data);
                            } else {
                                this.model = _.assign({}, this.owner);
                            }

                            if (this.model.tags && typeof this.model.tags == 'string') {
                                let arr_tags = this.model.tags.split(',');
                                arr_tags = _.map(arr_tags, e => {
                                    return {
                                        displayValue: e
                                    }
                                })
                                this.model.tags = arr_tags;
                            } else this.model['tags'] = [];

                            if (this.model.facebook && this.model.facebook.constructor.toString().indexOf("Array") == -1) {
                                this.model.facebook = [this.model.facebook];
                            }

                            setTimeout(function () {
                                this.is_load_data = false;
                            }.bind(this), 500);
                        })
                        this.filterUser();
                    }, 4500);

                } else {
                    this.toastr.error(res.message, 'Hợp nhất người dùng không thành công', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                }
                // this.modalRef.hide();
            }, error => {
                this.toastr.error(error.message, 'Lỗi', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });

            })
        }
    }

    getListUsers(request: any = {}, sort: any = {}) {
        this.listMergeUser = [];
        request.offset = this.page_size1 * (this.currentPageMergeUser <= 0 ? 0 : this.currentPageMergeUser - 1);
        request.limit = this.page_size1;

        this.contactService.list(request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.listMergeUser = res.data.list;
                this.listMergeUser.forEach(e => {
                    e.isMerged = false;
                })
                this.totalItemMergeUser = res.data.total;
                var pageString = (this.totalItemMergeUser / this.page_size1).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPageMergeUser = totalpage;


            } else {
                this.listMergeUser = [];
            }
        })
    }

    filterAgent() {
        let options = [];
        if (this.modelFilter.filter_agent_phone) {
            options.push({
                key: 'phone',
                condition: '=',
                value: this.modelFilter.filter_agent_phone
            })
        }
        if (this.modelFilter.group_id && this.modelFilter.group_id != '--Chọn--') {
            options.push({
                key: 'group_id',
                condition: '=',
                value: this.modelFilter.group_id
            })
        }
        // this.currentPage1 = 1;
        this.getStaffs({ filters: JSON.stringify(options) });
    }

    assignTickets(user_id, group_id?: any) {
        var y = confirm("Bạn có muốn những phiếu ghi này cho chuyên viên đã chọn không?");
        if (y) {
            let ids = [];
            this.allStatus.forEach(status => {
                if (this.selected[status.id]) {
                    Object.keys(this.selected[status.id]).forEach(e => {
                        if (this.selected[status.id][e]) {
                            ids.push(e);
                        }
                    });
                }
            });

            let payload = { assign_agent_id: user_id };
            if (group_id) {
                payload['assign_group_id'] = group_id;
            }
            this.is_load_data = true;
            this.ticketService.updateMany({ _id: { $in: ids } }, payload).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Chuyển không thành công" };
                        this.toastr.error('Chuyển không thành công', '', {
                            timeOut: 2000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.toastr.success('Chuyển thành công, vui lòng chờ trong giây lát để cập nhật thông tin', '', {
                            timeOut: 1000,
                            positionClass: 'toast-bottom-right'
                        });

                        setTimeout(() => {
                            this.is_load_data = false;
                            this.listTicket();
                            this.unSelect();
                        }, 4500);
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            })
        }

    }

    getStaffs(request: any = {}, sort: any = {}) {
        this.listAgent = [];
        request.offset = this.page_size1 * (this.currentPage1 <= 0 ? 0 : this.currentPage1 - 1);
        request.limit = this.page_size1;

        this.userService.list(request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.listAgent = res.data.list;
                this.totalItem1 = res.data.total;
                var pageString = (this.totalItem1 / this.page_size1).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage1 = totalpage;


            } else {
                this.listAgent = [];
            }
        })
    }

    listTicket(request?: any) {
        this.is_loading = true;
        this.ticketService.status().subscribe(res => {
            let statusList = res.data;
            this.allStatus = statusList;
            let tmp = [{
                id: '',
                text: ''
            }];
            statusList.forEach(e => {
                this.tickets[e.id] = [];
                this.totalItem[e.id] = 0;
                this.totalPage[e.id] = 0;
                this.currentPage[e.id] = 1;
                tmp.push({
                    id: e.id,
                    text: e.name
                })
            });
            this.status_select2 = tmp;
            let filter_more = {}
            if (this.filter_type == 'request') {
                filter_more = {
                    key: 'requester_id',
                    condition: '=',
                    value: this.owner._id
                }
            } else if (this.filter_type == 'assign') {
                filter_more = {
                    key: 'assign_agent_id',
                    condition: '=',
                    value: this.owner._id
                }
            } else if (this.filter_type == 'receiver') {
                filter_more = {
                    key: 'receiver_id',
                    condition: '=',
                    value: this.owner._id
                }
            }
            this.total = 0;
            this.ticketService.ticketsByListStatus(statusList, filter_more).toPromise().then(list => {
                if (!list) {
                    list = [];
                }
                list.forEach(subList => {
                    this.total += subList['data']['total'];
                    statusList.forEach(e => {
                        let check = _.find(subList['data']['tickets'], { status: e.id });
                        if (check) {
                            this.tickets[e.id] = subList['data']['tickets'];
                            let tmp_select = {};
                            this.tickets[e.id].forEach(_t => {
                                tmp_select[_t._id] = false;
                            });
                            this.selected[e.id] = tmp_select;
                            this.totalItem[e.id] = subList['data']['total'];
                            var pageString = (this.totalItem[e.id] / this.page_size).toString();
                            var pageSplit = pageString.split('.');
                            var last: any;
                            var totalpage = parseInt(pageSplit[0]);
                            if (pageSplit.length > 1) {
                                last = pageSplit[1];
                                if (parseInt(last) > 0) {
                                    totalpage++
                                }
                            }
                            this.totalPage[e.id] = totalpage;
                        }
                    })
                });
                this.is_loading = false;
            });
        });
    }


    loadData(status, request: any = {}, sort: any = {}) {
        this.tickets[status] = [];
        // this.isSelected[status] = false;
        // Sửa lại bộ đếm phiếu ghi nếu chỉ tính 'Tất cả' cho từng trang
        // Object.keys(this.selected[status]).forEach(ticket_id => {
        //     if (this.selected[status][ticket_id]) {
        //         if(this.selected[status][ticket_id] == true){
        //             this.mergeCount -= 1;
        //         }
        //     }
        // })
        // console.log(this.mergeCount);
        // this.selected[status] = {};

        request.offset = this.page_size * (this.currentPage[status] <= 0 ? 0 : this.currentPage[status] - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        let filter_more = {}
        if (this.filter_type == 'request') {
            filter_more = {
                key: 'requester_id',
                condition: '=',
                value: this.owner._id
            }
        } else if (this.filter_type == 'assign') {
            filter_more = {
                key: 'assign_agent_id',
                condition: '=',
                value: this.owner._id
            }
        } else if (this.filter_type == 'receiver') {
            filter_more = {
                key: 'receiver_id',
                condition: '=',
                value: this.owner._id
            }
        }
        request.filters = JSON.stringify([{
            key: 'status',
            condition: '=',
            value: status
        }, filter_more]);

        this.ticketService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.tickets[status] = res.data.tickets;
                this.isSelected[status] = true;
                res.data.tickets.forEach(e => {
                    if (!this.selected[status][e._id]) {
                        this.isSelected[status] = false;
                    }

                });
                this.totalItem[status] = res.data.total;
                var pageString = (this.totalItem[status] / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage[status] = totalpage;


            } else {
                this.tickets[status] = [];
            }

        }, err => {
            this.tickets[status] = [];
        });
    }

    openTicket(ticket: any) {
        this.userService.find({ _id: ticket.requester_id }).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                ticket.request = res.data;
                this.socketService.opentab(ticket, 'ticket', 'edit');
            }
        })
    }

    getMyFields() {
        this.fieldService.allField({ target: 'user' }).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.fields = res.data;
                this.fields.forEach(element => {
                    if (element.type == 'select') {
                        element.data.unshift("--Chọn--");
                    }
                });
            }
        })
    }

    getCity() {
        this.addressService.getCities().subscribe(res => {
            let citiesList = [
                '--Chọn--',
                {
                    id: '',
                    text: ''
                }
            ];
            res.data.cities.forEach((c: any) => {
                citiesList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.cities = citiesList;
        });
    }

    getDistrict(id: number) {
        this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
            let districts = [
                '--Chọn--',
                {
                    id: '',
                    text: ''
                }];
            res.data.districts.forEach((c: any) => {
                districts.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.districts = districts;
            console.log(this.model.district_id);
            console.log(this.districts);

        })
    }

    getGender() {
        this.allGender = [
            '--Chọn--',
            {
                id: '',
                text: ''
            }, {
                id: 'male',
                text: 'Nam giới'
            },
            {
                id: 'female',
                text: 'Nữ giới'
            }, {
                id: 'other',
                text: 'Khác'
            }
        ]
    }

    getOrganize() {
        this.organizeService.allOrganize().subscribe(res => {
            if (res.status == 200 && res.error == false) {
                let organizeList = [
                    '--Chọn--',
                    {
                        id: '',
                        text: ''
                    }
                ];
                res.data.forEach((c: any) => {
                    organizeList.push({
                        text: c.name,
                        // id: c.id, // lấy dữ liệu từ mysql
                        id: c.organize_id, //lấy dữ liệu từ mongo
                    });
                });
                // if (this.user.role == 'administrator') {
                //     organizeList.push({
                //         id: 'add',
                //         text: 'Thêm mới'
                //     })
                // }
                this.allOrganize = organizeList;
            }
        })
    }
    getRoles() {
        this.allRole = [
            // '--Chọn--',
            {
                id: '',
                text: ''
            },
            {
                id: 'end_user',
                text: 'Khách hàng'
            },
            {
                id: 'agent',
                text: 'Chuyên viên'
            },
            {
                id: 'supervisor',
                text: 'Supervisor'
            },
            {
                id: 'administrator',
                text: 'Administrator'
            }
        ]
    }

    getAccessTicket() {
        this.allAccessTicket = [
            '--Chọn--',
            {
                id: '',
                text: ''
            },
            {
                id: 'access-all-ticket',
                text: 'Truy cập toàn bộ phiếu ghi'
            },
            {
                id: 'access-my-ticket',
                text: 'Truy cập phiếu ghi của mình'
            },
            {
                id: 'access-group-ticket',
                text: 'Truy cập phiếu ghi của nhóm'
            },
            {
                id: 'access-org-ticket',
                text: 'Truy cập phiếu ghi của tổ chức'
            }
        ]

    }

    getAccessContact() {
        this.allAccessContact = [
            '--Chọn--',
            {
                id: '',
                text: ''
            },
            {
                id: 'access-all-contact',
                text: 'Truy cập toàn bộ khách hàng'
            },
            {
                id: 'access-my-contact',
                text: 'Truy cập khách hàng của mình'
            },
            {
                id: 'access-group-contact',
                text: 'Truy cập khách hàng của bộ phận'
            },
            {
                id: 'access-org-contact',
                text: 'Truy cập khách hàng của tổ chức'
            }
        ]

    }
    getRuleChat() {
        this.ruleChat = [
            '--Chọn--',
            {
                id: '',
                text: ''
            },
            {
                id: 'all-rule',
                text: 'All rule'
            },
            {
                id: 'only-text',
                text: 'Chat Text & Ảnh'
            },
            {
                id: 'only-file',
                text: 'Chat Text & File đính kèm'
            },
        ]
    }

    getGroup() {
        this.groupService.allGroup().toPromise().then(res => {
            let groupList = [
                // '--Chọn--',
                {
                    id: '',
                    text: '-Chọn-'
                }];

            let tmp_groupList = [//'--Chọn--',
                {
                    id: '',
                    text: '-Chọn-'
                }]

            res.data.forEach((c: any) => {
                groupList.push({
                    text: c.name,
                    id: c.id,
                });
                tmp_groupList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allFillterGroup = tmp_groupList;
            // if (this.user.role == 'administrator') {
            //     groupList.push({
            //         id: 'add',
            //         text: 'Thêm mới'
            //     })
            // }
            this.allGroup = groupList;
        });
    }

    changedName() {
        if (this.model.name) {
            this.model.name = this.model.name.trim();
        }
        // this.updateUser({ name: this.model.name });
    }

    saveField(field, key) {
        // let check = true;
        // if(field.is_required){
        //     if(field.type == "text" || field.type == "textarea" || field.type == "date"){
        //         if(!this.model[key] || (this.model[key] && this.model[key].trim() == "")){
        //             check = false;
        //             this.errorUpdate.push("Thuộc tính " + field.title + " không được bỏ trống");
        //         }
        //     } else if(field.type == "number"){
        //         if(!this.model[key] && this.model[key] != "0"){
        //             check = false;
        //             this.errorUpdate.push("Thuộc tính " + field.title + " không được bỏ trống");
        //         }
        //     }
        // }
        // if(check){
        //     let payload = {};
        if (this.model[key] && moment(this.model[key], "YYYY-MM-DD", true).isValid()) {
            this.model[key] = moment(this.model[key]).format('YYYY-MM-DD');
        }
        if (this.model[key]) {
            this.model[key] = this.model[key].toString().trim();
            // this.updateUser(payload);
        } else {
            this.model[key] = "";
            // this.updateUser(payload);
        }
        // }

    }

    changedValueMyField(e, field, key) {
        // var check = true;
        // if(field.is_required){
        //     if(field.type == "select"){
        //         if(!e.value || e.value == '--Chọn--'){
        //             check = false;
        //             this.errorUpdate.push("Thuộc tính " + field.title + " không được bỏ trống");
        //             // this.toastr.error("Thuộc tính " + field.title + " không được bỏ trống", "Lỗi", {
        //             //     timeOut: 4000,
        //             //     positionClass: 'toast-bottom-right'
        //             // });
        //         }
        //     } else if(field.type == "multi-select"){
        //         if(!e.value){
        //             check = false;
        //             this.errorUpdate.push("Thuộc tính " + field.title + " không được bỏ trống");
        //             // this.toastr.error("Thuộc tính " + field.title + " không được bỏ trống", "Lỗi", {
        //             //     timeOut: 4000,
        //             //     positionClass: 'toast-bottom-right'
        //             // });
        //         }
        //     }
        // }
        // if(check){
        if (!this.is_load_data) {
            let payload = {};
            if (e.value == '--Chọn--') {
                // payload[key] = '';
                this.model[key] = '';
            } else {
                // payload[key] = e.value;
                this.model[key] = e.value;
            }
            // this.model[key] = e.value;

            // this.updateUser(payload);
        }
        // }

    }

    deleteMoreItem(type, value?: any) {

        switch (type) {
            case 'phone': {
                this.deletePhone = false;
                if (!value) {
                    // this.updateUser({ phone: '' });
                    this.model.phone = '';
                } else {
                    // this.updateUser({ $pull: { sub_phone: value } })
                    this.model.$pull.sub_phone = value;
                    this.model.sub_phone = _.pull(this.model.sub_phone, value);
                }
                break;
            }
            case 'email': {
                this.deleteEmail = false;
                if (value) {
                    // this.updateUser({ $pull: { sub_email: value } })
                    this.model.$pull.sub_email = value;
                    this.model.sub_email = _.pull(this.model.sub_email, value);
                }
                break;
            }
            case 'facebook': {
                this.deleteFacebook = false;
                if (value) {
                    // this.updateUser({ $pull: { facebook: value } })
                    this.model.$pull.facebook = value;
                    this.model.facebook = _.pull(this.model.facebook, value);
                }
                break;
            }
            default: break;
        }
    }

    addMore(type) {
        switch (type) {
            case 'phone': {
                if (this.model.more_phone && this.model.more_phone.trim() != '') {
                    if (!this.model.phone) {
                        if (UtilityService.isValidPhoneNumber(this.model.more_phone.trim().replace(new RegExp(' ', 'g'), ''))) {
                            // this.updateUser({ phone: this.model.more_phone.trim().replace(new RegExp(' ','g'), '') });
                            this.payload_tmp.phone = this.model.more_phone.trim().replace(new RegExp(' ', 'g'), '');
                        } else {
                            this.errorUpdate.push("Số điện thoại không hợp lệ");
                        }
                    } else {
                        if (UtilityService.isValidPhoneNumber(this.model.more_phone.trim().replace(new RegExp(' ', 'g'), ''))) {
                            this.model.$addToSet.sub_phone = this.model.more_phone.trim().replace(new RegExp(' ', 'g'), '');
                            // if (this.model.sub_phone) this.model.sub_phone.push(this.model.more_phone.trim().replace(new RegExp(' ', 'g'), ''));
                        } else {
                            this.errorUpdate.push("Số điện thoại không hợp lệ");
                        }
                    }
                }
                break;
            }
            case 'email': {
                if (this.model.more_email && this.model.more_email.trim() != '') {
                    if (UtilityService.validateEmail(this.model.more_email)) {
                        if (!this.model.email) {
                            this.payload_tmp.email = this.model.more_email.trim().replace(new RegExp(' ', 'g'), '');
                            // this.updateUser({ email: this.model.more_email.trim() })
                        } else {
                            this.model.$addToSet.sub_email = this.model.more_email.trim().replace(new RegExp(' ', 'g'), '');
                            // if (this.model.sub_email) this.model.sub_email.push(this.model.more_email.trim().replace(new RegExp(' ', 'g'), ''));
                        }
                    } else {
                        this.errorUpdate.push("Email không hợp lệ");
                    }
                }
                break;
            }
            case 'facebook': {
                if (this.model.more_facebook && this.model.more_facebook.trim() != '') {
                    // this.updateUser({ $addToSet: { facebook: this.model.more_facebook.trim() } })
                    this.model.$addToSet.facebook = this.model.more_facebook.trim();
                    // if (this.model.facebook) this.model.facebook.push(this.model.more_facebook.trim());
                    // else this.model.facebook = [this.model.more_facebook.trim()];
                }
                break;
            }
            default: break;
        }
    }

    newTicket() {
        this.socketService.opentab({ request: this.owner }, 'ticket', 'new');
    }

    execCall(phone) {
        if (UtilityService.isValidPhoneNumber(phone)) {
            this.socketService.execCall(phone);
        } else {
            this.toastr.error('', 'Số điện thoại không hợp lệ', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
        }

    }

    // addTags() {
    //     let _tags_arr = [];
    //     this.model.tags.forEach(t => {
    //         _tags_arr.push(t.displayValue);
    //     });
    //     let _tags = (_tags_arr.length > 0) ? _tags_arr.join(',') : null;
    //     this.model.tags = _tags;
    //     // this.updateUser({ tags: _tags });
    // }

    changedAddress() {
        if (this.model.address && this.model.address.trim() != '') {
            this.model.address = this.model.address.trim();
            // this.updateUser({ address: this.model.address.trim() })
        }
    }

    changedAgentId() {
        if (this.model.agent_id && this.model.agent_id.trim() != '') {
            this.model.agent_id = this.model.agent_id.trim()
            // this.updateUser({ agent_id: this.model.agent_id.trim() })
        }
    }

    changedNote() {
        if (this.model.note && this.model.note.trim() != '') {
            this.model.note = this.model.note.trim();
            // this.updateUser({ note: this.model.note.trim() })
        }
    }

    changedPhone() {
        if (this.model.phone && this.model.phone.trim() != '') {
            this.model.phone = this.model.phone.trim().replace(new RegExp(' ', 'g'), '');
        }
    }

    changedEmail() {
        if (this.model.email && this.model.email.trim() != '') {
            // this.updateUser({ email: this.model.email.trim() })
            this.model.email = this.model.email.trim();
        }
    }
    changedGender(e: any) {
        if (!this.is_load_data) {
            if (e.value != '') {
                // this.updateUser({ gender: e.value });
                this.model.gender = e.value;
            }
        }
    }

    changedCustomerType(e: any) {
        if (!this.is_load_data) {
            if (e.value != '') {
                // this.updateUser({ customer_type: e.value });
                this.model.customer_type = e.value;
            }
        }
    }

    changedCity(e: any) {
        if (!this.is_load_data) {
            if (e.value != '') {
                // this.updateUser({ city_id: parseInt(e.value) });
                this.model.city_id = parseInt(e.value);
                this.getDistrict(e.value);
            }
        } else {
            if (e.value != '') {
                this.getDistrict(e.value);
            }
        }
    }

    changedDistrict(e: any) {
        if (!this.is_load_data && !this.is_load_district_follow_city) {
            if (e.value != '') {
                // this.updateUser({ district_id: parseInt(e.value) });
                this.model.district_id = parseInt(e.value);
            }
        }
    }

    changedAccessContact(e: any) {
        if (!this.is_load_data) {
            if (e.value != '') {
                let payload = {};
                if (this.model.access) payload = this.owner.access;
                payload['contact'] = e.value;
                // this.updateUser({ access: payload });
                this.model.access = payload;
            }
        }
    }
    changedRuleChat(e: any) {
        if (!this.is_load_data) {
            if (e.value != '') {
                this.model.rule_chat = e.value;
                // this.updateUser({ rule_chat: e.value });
                // this.model.access = payload;
            }
        }
    }
    changedAccessTicket(e: any) {
        if (!this.is_load_data) {
            if (e.value != '') {
                let payload = {};
                if (this.model.access) payload = this.owner.access;
                payload['ticket'] = e.value;
                this.model.access = payload;
                // this.updateUser({ access: payload });
                // this.model.access = payload;
            }
        }
    }

    changedRole(e: any) {
        if (!this.is_load_data) {
            if (e.value != '') {
                this.is_load_data = true;
                // this.updateUser({ role: e.value });
                this.model.role = e.value;
            }
        }
    }

    openMergeUser() {
        this.modelMerge = {
            filter_name: "",
            filter_email: "",
            filter_phone: "",
            searched: false
        }

        this.listMergeUser = [];
        this.currentPageMergeUser = 1;
        this.totalItemMergeUser = 0;
        this.totalPageMergeUser = 0;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(this.templateMergeUser, config);
        this.filterUser();
    }

    changedGroup(e: any): void {
        if (!this.is_load_data) {
            if (e.value == 'add') {
                let config = {
                    backdrop: true,
                    ignoreBackdropClick: true,
                    keyboard: false
                }
                this.modalRef = this.modalService.show(this.templateGroup, config);
            } else if (e.value != '') {
                this.model.group_id = parseInt(e.value);
                // this.updateUser({ group_id: parseInt(e.value) });
                // this.model.group_id = e.value;
            }
        }
    }

    addGroup() {
        this.groupService.create(this.modelGroup).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.message = { class: "alert dark alert-danger", content: "Lưu không thành công" };
                    this.toastr.error('Lưu không thành công', '', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.getGroup();
                    this.modalRef.hide();
                    // this.updateUser({ group_id: parseInt(res.data.id) })
                    this.model.group_id = parseInt(res.data.id);
                    setTimeout(function () {
                        this.owner.group_id = res.data.id;
                    }.bind(this), 500);
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        })
    }

    changedOrganize(e: any) {
        if (!this.is_load_data) {
            if (e.value == 'add') {
                this.modelOrganize = {};
                let config = {
                    backdrop: true,
                    ignoreBackdropClick: true,
                    keyboard: false
                }
                this.modalRef = this.modalService.show(this.templateOrganize, config);
            } else if (e.value != '' && typeof (e.value) != 'object') { // 'object' khi bấm huy, 'add' khi bấm lưu trong templateOrganize gọi thêm hàm updateUser
                if (e.value == '--Chọn--') {
                    if (!this.is_add_org) {
                        // this.updateUser({ organize_id: parseInt(e.value) });
                        this.model.organize_id = parseInt(e.value);
                    }

                } else {
                    this.model.organize_id = parseInt(e.value);
                    // this.updateUser({ organize_id: parseInt(e.value) });
                }


                // this.model.organize_id = e.value;
            }
        }
    }

    addOrganize() {
        this.is_add_org = true;
        this.organizeService.create(this.modelOrganize).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.getOrganize();
                this.modalRef.hide();
                this.toastr.info('Lưu thành công', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
                setTimeout(function () {
                    this.model.organize_id = res.data.id;
                    setTimeout(() => {
                        this.is_add_org = false;
                    }, 1000);
                }.bind(this), 500);
                // this.updateUser({ organize_id: parseInt(res.data.id) });

            } else {
                this.toastr.error('Lưu không thành công', '', {
                    timeOut: 1000,
                    positionClass: 'toast-bottom-right'
                });
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
            setTimeout(() => this.message = null, 3000);
        })
    }


    updateUser() {
        //abcde
        this.errorUpdate = [];
        let check = true;
        this.fields.forEach(e => {

            if (e.is_required) {
                if (e.type == "number") {
                    if (!this.model[e.key] && this.model[e.key] != '0') {
                        check = false;
                        this.errorUpdate.push("Thuộc tính " + e.title + " không được bỏ trống");
                    }
                } else if (e.type == "text" || e.type == "textarea" || e.type == "date") {
                    if (!this.model[e.key] || (this.model[e.key] && this.model[e.key].trim() == "")) {
                        check = false;
                        this.errorUpdate.push("Thuộc tính " + e.title + " không được bỏ trống");
                    }
                } else if (e.type == "select") {
                    if (!this.model[e.key] || this.model[e.key] == '--Chọn--') {
                        check = false;
                        this.errorUpdate.push("Thuộc tính " + e.title + " không được bỏ trống");
                    }
                } else if (e.type == "multi-select") {
                    if (!this.model[e.key]) {
                        check = false;
                        this.errorUpdate.push("Thuộc tính " + e.title + " không được bỏ trống");
                    }
                }
            }
        });

        if (check) {
            var payload = _.assign({}, this.model);
            if(this.payload_tmp.phone){
                payload.phone = this.payload_tmp.phone;
            }
            if(this.payload_tmp.email){
                payload.email = this.payload_tmp.email;
            }
            if (payload.tags && payload.tags.length > 0) {
                let _tags_arr = [];
                payload.tags.forEach(t => {
                    _tags_arr.push(t.displayValue);
                });
                let _tags = (_tags_arr.length > 0) ? _tags_arr.join(',') : null;
                payload.tags = _tags;
            }
            if (this.user.role != 'administrator') {
                delete payload.role;
                delete payload.access;
                delete payload.group_id;
            }
            if (payload.city_id) {
                this.is_load_district_follow_city = true;
            }

            if (payload.phone && !UtilityService.isValidPhoneNumber(payload.phone)) {
                this.errorUpdate.push("Số điện thoại không hợp lệ");
            }
        } else {
            var payload = {}
        }
        if (payload.more_phone) {
            delete payload.more_phone;
        }
        if (payload.more_email) {
            delete payload.more_email;
        }
        if (payload.more_facebook) {
            delete payload.more_facebook;
        }
        // Xóa sub_xxx để k lỗi MongoDB 
        if (payload.sub_phone) {
            delete payload.sub_phone;
        }
        if (payload.sub_email) {
            delete payload.sub_email;
        }
        if (payload.facebook) {
            delete payload.facebook;
        }

        if (this.errorUpdate.length == 0) {
            this.userService.update(this.owner._id, payload).subscribe(res => {
                setTimeout(() => {
                    this.is_load_data = false;
                    this.is_load_district_follow_city = false;
                }, 1000);
                if (this.user._id == res.data._id) {
                    this.userService.updateCurentTime(res.data);
                }
                if (res.status == 200 && res.error == false) {
                    if(this.model.more_phone){
                        if (!this.model.phone) {
                            this.model.phone = this.model.more_phone.trim().replace(new RegExp(' ', 'g'), '');
                        } else {
                            if(this.model.sub_phone && this.model.sub_phone.length > 0){
                                this.model.sub_phone.push(this.model.more_phone.trim().replace(new RegExp(' ', 'g'), ''));
                            } else {
                                this.model.sub_phone = [this.model.more_phone.trim().replace(new RegExp(' ', 'g'), '')]
                            }
                        }              
                        
                    }
                    delete this.model.more_phone;
                    if(this.model.more_email){
                        if (!this.model.email) {
                            this.model.email = this.model.more_email.trim().replace(new RegExp(' ', 'g'), '');
                        } else {
                            if(this.model.sub_email && this.model.sub_email.length > 0){
                                this.model.sub_email.push(this.model.more_email.trim().replace(new RegExp(' ', 'g'), ''));
                            } else {
                                this.model.sub_email = [this.model.more_email.trim().replace(new RegExp(' ', 'g'), '')]
                            }
                        }
                        
                    }
                    delete this.model.more_email;
                    if(this.model.more_facebook){
                        if(this.model.facebook && this.model.facebook.length > 0){
                            this.model.facebook.push(this.model.more_facebook.trim().replace(new RegExp(' ', 'g'), ''));
                        } else {
                            this.model.facebook = [this.model.more_facebook.trim().replace(new RegExp(' ', 'g'), '')]
                        }
                    }
                    delete this.model.more_facebook;
                    
                    this.addPhone = false;
                    this.addEmail = false;
                    this.addFacebook = false;
                    this.deletePhone = true;
                    this.deleteEmail = true;
                    this.deleteFacebook = true;
                    this.model.$addToSet = {}
                    this.model.$pull = {}
                    this.toastr.info('Lưu thành công', '', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right',
                    });
                    this.comeback.emit({
                        requester_id: this.owner._id
                    })
                } else {
                    this.toastr.error('Lưu không thành công', '', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                }
            }, err => {
                setTimeout(() => {
                    this.is_load_data = false;
                    this.is_load_district_follow_city = false;
                }, 1000);
                this.toastr.error(err.message, 'Lưu không thành công', {
                    timeOut: 3000,
                    positionClass: 'toast-bottom-right'
                });
            })
        } else {
            this.addPhone = false;
            this.addEmail = false;
            this.addFacebook = false;
            this.model.$addToSet = {}
            this.model.$pull = {}
            this.errorUpdate.forEach(e => {
                this.toastr.error(e, "Lỗi", {
                    timeOut: 1000,
                    positionClass: 'toast-bottom-right'
                });
            })

        }

    }

    setPage(status, page: number) {
        if (page <= this.totalPage[status]) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage[status]) {
                this.currentPage[status] = page;
                this.loadData(status);
            }
        }
        else {

            page = this.totalPage[status];
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage[status]) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage[status]) {
                    this.currentPage[status] = page;
                    this.loadData(status);
                }
            }
        }
    }

    goPage2(status, toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(status, toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

    // function for result template
    public templateResult: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
        if (state.id == 'add') {
            return jQuery('<i class="icon fa fa-plus"></><span class="ml-10">' + state.text + '</span>')
        } else {
            return state.text;
        }
    }

    // function for selection template
    public templateSelection: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
        if (state.id == 'add') {
            return jQuery('<i class="icon fa fa-plus"></><span class="ml-10">' + state.text + '</span>')
        } else {
            return state.text;
        }
    }

    setPage1(page: number) {
        if (page <= this.totalPage1) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage1) {
                this.currentPage1 = page;
                // this.getStaffs()
                this.filterAgent();
            }
        }
        else {

            page = this.totalPage1;
            $('#inputPage1').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage1) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage1) {
                    this.currentPage1 = page;
                    // this.getStaffs();
                    this.filterAgent();
                }
            }
        }
    }

    goPage21(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage1(toPage);
        }
    }

    _keyPress1(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

    setPageMergeUser(page: number) {
        if (page <= this.totalPageMergeUser) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPageMergeUser) {
                this.currentPageMergeUser = page;
                this.getListUsers({ filters: JSON.stringify(this.optionMerge) });
            }
        }
        else {

            page = this.totalPageMergeUser;
            $('#inputPage2').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPageMergeUser) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPageMergeUser) {
                    this.currentPageMergeUser = page;
                    this.getListUsers({ filters: JSON.stringify(this.optionMerge) });
                }
            }
        }
    }

    goPageMergeUser(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPageMergeUser(toPage);
        }
    }

    _keyPressPageMergeUser(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/tabs/user/detail_user.component.ts